// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3WI8Y","label":"Section_label__1oAKU","contentWrap":"Section_contentWrap__2nFa_","footer":"Section_footer__1hZHI","footerInner":"Section_footerInner__3T9nS"};